import { useContext } from "react";
import { MaterialSpecsContext } from "pages/MaterialSpecs/components";

export const useMaterialSpecs = () => useContext(MaterialSpecsContext);
